import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ECircleMark',
    props: {
        theme: {},
        isHovering: { type: Boolean }
    },
    setup: function (__props) {
        var props = __props;
        var themeClass = computed(function () {
            return {
                green: 'e-circle-mark--green',
                gray: 'e-circle-mark--gray',
            }[props.theme];
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([[themeClass.value, _ctx.isHovering && 'hover'], "e-circle-mark"])
            }, null, 2));
        };
    }
});
